import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import {
  CountyDto,
  CountyServiceServiceProxy,
  FarmerDto,
  FarmerServiceServiceProxy,
  FarmerCountyDto,
  UserServiceProxy,
  FarmerCropQuantityDto,
  CropDto,
  CropServiceServiceProxy,
  NutrientSourceServiceServiceProxy,
  NutrientSourceDto,
  FarmerNutrientSourceQuantityDto,
  FarmerCountyServiceServiceProxy,
  FarmerCropQuantityServiceServiceProxy,
  FarmerNutrientSourceQuantityServiceServiceProxy,
  UserDto,
  FarmerManureStorageServiceServiceProxy,
  FarmerManureStorageDto,
  CostShareDto,
  FarmerCostShareDto,
  FarmerCostShareServiceServiceProxy,
  CostShareServiceServiceProxy,
  WatershedServiceServiceProxy,
  FarmerWatershedServiceServiceProxy,
  FarmerWatershedDto,
  WatershedDto,
  NMPTypeDto,
  NMPTypeServiceServiceProxy,
  FarmerNutrientRecommendationQuantityDto,
  NutrientRecommendationDto,
  NutrientRecommendationServiceServiceProxy,
  FarmerNutrientRecommendationQuantityServiceServiceProxy,
  CCertificationDto,
  CertificationServiceServiceProxy,
  CreateUserDto,
  FarmerCreateDto,
  FarmerSaveDto,
  CCertificationCreateInput,
  CCertificationStatusEnum
} from '@shared/service-proxies/service-proxies';
import { AlertController, LoadingController, ModalController, IonInput, Platform, NavController } from '@ionic/angular';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { IonRadioGroup } from '@ionic/angular';
import { ManureStoragePage } from './manure-storage/manure-storage.page';
import { AppConsts } from '@shared/AppConsts';
import { FeatureMap } from '@shared/models/feature-map';
import { AppSessionService } from '@shared/session/app-session.service';
import { createTextMaskInputElement } from 'text-mask-core';
import * as moment from 'moment'; 
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-farmer',
  templateUrl: './farmer.page.html',
  styleUrls: ['./farmer.page.scss']
})
export class FarmerPage implements OnInit {

  id: number;
  farmer: FarmerDto;
  user: UserDto;
  farmerCounties: FarmerCountyDto[] = [];
  farmerCropQuantities: FarmerCropQuantityDto[] = [];
  farmerNutrientSourceQuantities: FarmerNutrientSourceQuantityDto[] = [];
  farmerNutrientRecommendationQuantities: FarmerNutrientRecommendationQuantityDto[] = [];
  farmerManureStorages: FarmerManureStorageDto[] = [];
  farmerCostShares: FarmerCostShareDto[] = [];
  farmerWatersheds: FarmerWatershedDto[] = [];
  formGroup: FormGroup;
  counties: CountyDto[] = [];
  crops: CropDto[] = [];
  nutrientSources: NutrientSourceDto[] = [];
  nutrientRecommendations: NutrientRecommendationDto[] = [];
  costShares: CostShareDto[] = [];
  watersheds: WatershedDto[] = [];
  nmpTypes: NMPTypeDto[] = [];
  certifications: CCertificationDto[];
  watershedlink = 'https://www.epa.ohio.gov/portals/35/tmdl/2010IntReport/Section%20K%20-%20HUC8_basemap.pdf';
  maxDate: string = (new Date()).toISOString();
  isLoaded: boolean = false;
  intervalId: any;
  isSaving: boolean = false;
  isSavingFarmerCounties: boolean = false;
  isSavingFarmerCropQuantities: boolean = false;
  isSavingFarmerNutrientSourceQuantities: boolean = false;
  isSavingFarmerNutrientRecommendationQuantities: boolean = false;
  isSavingFarmerCostShares: boolean = false;
  isSavingFarmerWatersheds: boolean = false;
encToken :string;
  // prettier-ignore
  private phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  get phoneNumber() {
    return this.formGroup.get('phoneNumber') as FormControl;
  }

  @ViewChild('phoneInput', { static: false })
  public set phoneInput(value: IonInput) {
    if (!value) {
      return;
    }

    value.getInputElement().then(input => this.registerTextMask(input));
  }

  nmpDatePickerObj: any = {
    inputDate: new Date(),
    toDate: new Date(),
    showTodayButton: false,
    // closeOnSelect: true,
    setLabel: 'Select',
    titleLabel: 'Select a Date',
    dateFormat: 'MM/DD/YYYY'
  };

  factDatePickerObj: any = {
    inputDate: new Date(),
    toDate: new Date(),
    showTodayButton: false,
    // closeOnSelect: true,
    setLabel: 'Select',
    titleLabel: 'Select a Date',
    dateFormat: 'MM/DD/YYYY'
  };

  private baseUrl: string = AppConsts.remoteServiceBaseUrl;

  constructor(
    private formBuilder: FormBuilder,
    private countyService: CountyServiceServiceProxy,
    private alertController: AlertController,
    private modalController: ModalController,
    storageService: AppStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private farmerSvc: FarmerServiceServiceProxy,
    private userService: UserServiceProxy,
    private cropService: CropServiceServiceProxy,
    private nutrientSourceService: NutrientSourceServiceServiceProxy,
    private nutrientRecommendationService: NutrientRecommendationServiceServiceProxy,
    private costShareService: CostShareServiceServiceProxy,
    private watershedService: WatershedServiceServiceProxy,
    private nmpTypeService: NMPTypeServiceServiceProxy,
    private loadingController: LoadingController,
    private farmerCountyService: FarmerCountyServiceServiceProxy,
    private farmerCropQuantityService: FarmerCropQuantityServiceServiceProxy,
    private farmerNutrientSourceQuantityService: FarmerNutrientSourceQuantityServiceServiceProxy,
    private farmerNutrientRecommendationQuantityService: FarmerNutrientRecommendationQuantityServiceServiceProxy,
    private farmerManureStorageService: FarmerManureStorageServiceServiceProxy,
    private farmerCostShareService: FarmerCostShareServiceServiceProxy,
    private farmerWatershedService: FarmerWatershedServiceServiceProxy,
    private certificationService: CertificationServiceServiceProxy,
    private appSessionService: AppSessionService,
    private permissionChecker: PermissionCheckerService,
    private platform: Platform,
    private titleService: Title,    
    private appStorageService: AppStorageService,
    private navCtrl: NavController
  ) {
    storageService.IsLoadedSubject.subscribe(x => {
      if (!this.isLoaded && x) {
        appStorageService.EncryptedTokenSubject.subscribe(y => this.encToken = y);
        this.route.queryParams.subscribe(params => {
          if (params && params.farmerId) {
            this.id = +params.farmerId;
            // so for whatever reason navigating with params from app.component will not set the
            // farmer id in the url so have to force it here....................................
            this.router.navigate([], { queryParams: { farmerId: this.id } });
            if (this.id > 0) {
              this.getFarmer();
            } else {
              this.initializeNewFarmer();
            }
          }
          else if (appSessionService.farmerId) {
            this.id = appSessionService.farmerId;
            // so for whatever reason navigating with params from app.component will not set the
            // farmer id in the url so have to force it here....................................
            this.router.navigate([], { queryParams: { farmerId: this.id } });
            this.getFarmer();
          } else {
            this.initializeNewFarmer();
          }
          this.getCounties();
          this.getCrops();
          this.getNutrientSources();
          this.getNutrientRecommendations();
          this.getCostShares();
          this.getWatersheds();
          this.getNMPTypes();
          this.isLoaded = true;
        });
      }
    });
    this.setupForm();
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.titleService.setTitle('OACI - Farmer Profile');
    this.setupForm();
    this.clearRelatedEntities();
    this.intervalId = setInterval(() => {
      if (!this.isSaving) this.saveFarmer(true, true);
    }, 1 * 60 * 1000); // every minute
  }

  // ionViewWillLeave(){
  ionViewDidLeave(){
    clearInterval(this.intervalId);
    /*if (this.router.url.indexOf('/account/login') == -1)*/ this.saveFarmer(true, true);
    this.initializeNewFarmer();
  }

  setupForm() {
    if (this.formGroup) {
      this.formGroup.reset();
    }
    this.formGroup = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      userName:['',Validators.required],
      farmName: ['', this.id ? Validators.required : null],
      address: ['', this.id ? Validators.required : null],
      city: ['', this.id ? Validators.required : null],
      zipCode: ['', this.id ? Validators.required : null],
      ownedAcres: ['', this.id ? Validators.required : null],
      rentedAcres: ['', this.id ? Validators.required : null],
      nmpComplete: ['', this.id ? Validators.required : null],
      nmpCompletionDate: [''],
      nmpHasBeenStarted: [''],
      nmpTypeId: [''],
      nmpAcreageQuantity: [''],
      factComplete: ['', this.id ? Validators.required : null],
      factCompletionDate: [''],
      nutrientApplication: ['', this.id ? Validators.required : null],
      sensitiveAreas: ['', this.id ? Validators.required : null],
      infoRepresentsEntireFarmingOperation: [null, this.id ? Validators.requiredTrue : null],
      infoSubjectToAuditByIndependentAuditors: [null, this.id ? Validators.requiredTrue : null],
      infoFairAndAccurateToBestAbility: [null, this.id ? Validators.requiredTrue : null]
    });
  }

  makeFarmerFieldsRequired() {
    this.formGroup.controls.farmName.setValidators([Validators.required]);
    this.formGroup.controls.address.setValidators([Validators.required]);
    this.formGroup.controls.city.setValidators([Validators.required]);
    this.formGroup.controls.zipCode.setValidators([Validators.required]);
    this.formGroup.controls.ownedAcres.setValidators([Validators.required]);
    this.formGroup.controls.rentedAcres.setValidators([Validators.required]);
    this.formGroup.controls.nmpComplete.setValidators([Validators.required]);
    this.formGroup.controls.factComplete.setValidators([Validators.required]);
    this.formGroup.controls.nutrientApplication.setValidators([Validators.required]);
    this.formGroup.controls.sensitiveAreas.setValidators([Validators.required]);
    this.formGroup.controls.infoRepresentsEntireFarmingOperation.setValidators([Validators.requiredTrue]);
    this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.setValidators([Validators.requiredTrue]);
    this.formGroup.controls.infoFairAndAccurateToBestAbility.setValidators([Validators.requiredTrue]);
    this.formGroup.controls.farmName.updateValueAndValidity();
    this.formGroup.controls.address.updateValueAndValidity();
    this.formGroup.controls.city.updateValueAndValidity();
    this.formGroup.controls.zipCode.updateValueAndValidity();
    this.formGroup.controls.ownedAcres.updateValueAndValidity();
    this.formGroup.controls.rentedAcres.updateValueAndValidity();
    this.formGroup.controls.nmpComplete.updateValueAndValidity();
    this.formGroup.controls.factComplete.updateValueAndValidity();
    this.formGroup.controls.nutrientApplication.updateValueAndValidity();
    this.formGroup.controls.sensitiveAreas.updateValueAndValidity();
    this.formGroup.controls.infoRepresentsEntireFarmingOperation.updateValueAndValidity();
    this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.updateValueAndValidity();
    this.formGroup.controls.infoFairAndAccurateToBestAbility.updateValueAndValidity();
  }

  getCounties() {
    this.countyService.getAll().subscribe(counties => {
      this.counties = counties;
    });
  }

  getCrops() {
    this.cropService.getAll().subscribe(crops => {
      this.crops = crops;
      if (!this.id) {
        // this.addDefaultCropQuantitiesIfNeeded();
      }
    });
  }

  getNutrientSources() {
    this.nutrientSourceService.getAll().subscribe(nutrientSources => {
      this.nutrientSources = nutrientSources;
      if (!this.id) {
        this.addDefaultNutrientSourceQuantitiesIfNeeded();
      }
    });
  }

  getNutrientRecommendations() {
    this.nutrientRecommendationService.getAll().subscribe(nutrientRecommendations => {
      this.nutrientRecommendations = nutrientRecommendations;
    });
  }

  getCostShares() {
    this.costShareService.getAll().subscribe(costShares => {
      this.costShares = costShares;
    });
  }

  getWatersheds() {
    this.watershedService.getAll().subscribe(watersheds => {
      this.watersheds = watersheds;
    });
  }

  getNMPTypes() {
    this.nmpTypeService.getAll().subscribe(nmpTypes => {
      this.nmpTypes = nmpTypes;
    });
  }

  async getFarmer() {

    const loading = await this.loadingController.create({
      message: 'Fetching farmer profile...',
    });
    await loading.present();

    this.farmerSvc.get(this.id).subscribe(async farmer => {
      this.farmer = farmer;
      if (this.farmer) {
        this.getUser();
        this.loadFarmerFields();
        this.getAllRelatedEntities();
        await loading.dismiss();
      }
    });
  }

  async getUser() {

    this.userService.get(this.farmer.userId).subscribe(async user => {
      this.user = user;
      if (this.user) {
        this.loadUserFields();
      }
    });
  }

  getAllRelatedEntities() {
    this.getFarmerCounties();
    this.getFarmerCropQuantities();
    this.getFarmerNutrientSourceQuantities();
    this.getFarmerNutrientRecommendationQuantities();
    this.getFarmerManureStorages();
    this.getFarmerCostShares();
    this.getFarmerWatersheds();
    this.getFarmerCertifications();
  }

  clearRelatedEntities() {
    this.farmerCounties = [];
    this.farmerCropQuantities = [];
    this.farmerNutrientSourceQuantities = [];
    this.farmerNutrientRecommendationQuantities = [];
    this.farmerManureStorages = [];
    this.farmerCostShares = [];
    this.farmerWatersheds = [];
  }

  getFarmerCounties() {
    this.farmerCountyService.getAllByFarmerId(this.id).subscribe(farmerCountiesResponse => {
      this.farmerCounties = farmerCountiesResponse;
      this.sortFarmerCounties();
    });
  }

  getFarmerCropQuantities() {
    this.farmerCropQuantityService.getAllByFarmerId(this.id).subscribe(farmerCropQuantitiesResponse => {
      this.farmerCropQuantities = farmerCropQuantitiesResponse;
      // this.addDefaultCropQuantitiesIfNeeded();
      this.sortfarmerCropQuantities();
    });
  }

  getFarmerNutrientSourceQuantities() {
    this.farmerNutrientSourceQuantityService.getAllByFarmerId(this.id).subscribe(farmerNutrientSourceQuantitiesResponse => {
      this.farmerNutrientSourceQuantities = farmerNutrientSourceQuantitiesResponse;
      this.addDefaultNutrientSourceQuantitiesIfNeeded();
      this.sortFarmerNutrientSourceQuantities();
    });
  }

  getFarmerNutrientRecommendationQuantities() {
    this.farmerNutrientRecommendationQuantityService.getAllByFarmerId(this.id).subscribe(farmerNutrientRecommendationQuantitiesResponse => {
      this.farmerNutrientRecommendationQuantities = farmerNutrientRecommendationQuantitiesResponse;
      this.sortFarmerNutrientRecommendationQuantities();
    });
  }

  getFarmerManureStorages() {
    this.farmerManureStorageService.getAllByFarmerId(this.id).subscribe(farmerManureStoragesResponse => {
      this.farmerManureStorages = farmerManureStoragesResponse;
      this.sortFarmerManureStorages();
    });
  }

  getFarmerCostShares() {
    this.farmerCostShareService.getAllByFarmerId(this.id).subscribe(farmerCostSharesResponse => {
      this.farmerCostShares = farmerCostSharesResponse;
      this.sortFarmerCostShares();
    });
  }

  getFarmerWatersheds() {
    this.farmerWatershedService.getAllByFarmerId(this.id).subscribe(farmerWatershedsResponse => {
      this.farmerWatersheds = farmerWatershedsResponse;
      this.sortFarmerWatersheds();
    });
  }

  loadFarmerFields() {
    const farmer = this.farmer;
    this.formGroup.patchValue({
      farmName: farmer.farmName,
      address: farmer.address,
      city: farmer.city,
      zipCode: farmer.zipCode,
      ownedAcres: farmer.ownedAcres,
      rentedAcres: farmer.rentedAcres,
      nmpComplete: farmer.nmpComplete,
      nmpCompletionDate: farmer.nmpCompletionDate ? moment(farmer.nmpCompletionDate).format('MM/DD/YYYY') : null,
      nmpHasBeenStarted: farmer.nmpHasBeenStarted,
      nmpTypeId: farmer.nmpTypeId,
      nmpAcreageQuantity: farmer.nmpAcreageQuantity,
      factComplete: farmer.factComplete,
      factCompletionDate: farmer.factCompletionDate ? moment(farmer.factCompletionDate).format('MM/DD/YYYY') : null,
      nutrientApplication: farmer.nutrientApplication,
      sensitiveAreas: farmer.sensitiveAreas,
      infoRepresentsEntireFarmingOperation: farmer.infoRepresentsEntireFarmingOperation,
      infoSubjectToAuditByIndependentAuditors: farmer.infoSubjectToAuditByIndependentAuditors,
      infoFairAndAccurateToBestAbility: farmer.infoFairAndAccurateToBestAbility
    });
    this.enableOrDisableInformationCheckboxes();
    if (farmer.nmpCompletionDate) {
      this.nmpDatePickerObj.inputDate = farmer.nmpCompletionDate;
    }
    if (farmer.factCompletionDate) {
      this.factDatePickerObj.inputDate = farmer.factCompletionDate;
    }
    this.nmpCompleteRadioSelect(null);
    this.factCompleteRadioSelect(null);
  }

  loadUserFields() {
    const user = this.user;
    this.formGroup.patchValue({
      firstName: user.firstName,
      lastName: user.lastName,
      emailAddress: user.emailAddress,
      phoneNumber: user.phoneNumber,
      userName:user.userName
    });
  }

  getFarmerCertifications() {
    this.certificationService.getAll(true, this.id).subscribe(response => {
      const completedCerts = response.items
        .filter(x => x.statusId == CCertificationStatusEnum._2);
      const completedCertYears = Array.from(new Set(completedCerts.map(x => x.year)));
      const completedCertIdsToRemove = [];
      completedCertYears.forEach(year => {
        const certsForYear = completedCerts.filter(x => x.year == year);
        const certWithBestScoreId = certsForYear
          .reduce((prev, current) => (prev.score > current.score) ? prev : current).id;
          completedCertIdsToRemove.push.apply(
            completedCertIdsToRemove,
            certsForYear.filter(x => x.id != certWithBestScoreId).map(x => x.id)
          );
      });
      this.certifications = response.items.filter(x => completedCertIdsToRemove.indexOf(x.id) == -1);
    });
  }

  removeCounty(farmerCounty: FarmerCountyDto) {
    if (farmerCounty.id > 0) {
      this.farmerCountyService.delete(farmerCounty.id).subscribe(() => { });
    }
    const index = this.farmerCounties.indexOf(farmerCounty);
    this.farmerCounties.splice(index, 1);
  }

  removeCrop(farmerCropQuantity: FarmerCropQuantityDto) {
    if (farmerCropQuantity.id > 0) {
      this.farmerCropQuantityService.delete(farmerCropQuantity.id).subscribe(() => { });
    }
    const index = this.farmerCropQuantities.indexOf(farmerCropQuantity);
    this.farmerCropQuantities.splice(index, 1);
  }

  removeWatershed(farmerWatershed: FarmerWatershedDto) {
    if (farmerWatershed.id > 0) {
      this.farmerWatershedService.delete(farmerWatershed.id).subscribe(() => { });
    }
    const index = this.farmerWatersheds.indexOf(farmerWatershed);
    this.farmerWatersheds.splice(index, 1);
  }

  async addNewCounty() {
    const checkBoxes = [];
    this.counties
      .filter(county =>
        this.farmerCounties.map(fc => fc.countyId).indexOf(county.id) == -1
      )
      .forEach(county => {
        checkBoxes.push({
          name: county.name,
          type: 'checkbox',
          label: county.name,
          value: county.id,
          checked: false
        });
      });
    const alert = await this.alertController.create({
      header: 'County(s)',
      inputs: checkBoxes,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (countyIds) => {
            countyIds.forEach(countyId => {
              const farmerCounty = new FarmerCountyDto();
              farmerCounty.countyId = countyId;
              farmerCounty.countyName = this.counties.find(c => c.id == countyId).name;
              farmerCounty.farmerId = this.id ? this.id : 0;
              this.farmerCounties.push(farmerCounty);
            });
            this.sortFarmerCounties();
            this.saveFarmer(true, true);
          }
        }
      ]
    });

    await alert.present();
  }

  sortFarmerCounties() {
    this.farmerCounties = this.farmerCounties.sort(this.sortFarmerCounty);
  }

  sortFarmerCounty(a: FarmerCountyDto, b: FarmerCountyDto) {
    return a.countyName > b.countyName ? 1 : a.countyName < b.countyName ? -1 : 0;
  }

  async addCrop() {
    const checkBoxes = [];
    this.crops
      .filter(crop =>
        this.farmerCropQuantities.map(fc => fc.cropId).indexOf(crop.id) == -1
      )
      .forEach(crop => {
        checkBoxes.push({
          name: crop.name,
          type: 'checkbox',
          label: crop.name,
          value: crop.id,
          checked: false
        });
      });
    const alert = await this.alertController.create({
      header: 'Crop(s)',
      inputs: checkBoxes,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (cropIds) => {
            cropIds.forEach(cropId => {
              const farmerCropQuantity = new FarmerCropQuantityDto();
              farmerCropQuantity.cropId = cropId;
              farmerCropQuantity.cropName = this.crops.find(c => c.id == cropId).name;
              farmerCropQuantity.cropIsDefault = this.crops.find(c => c.id == cropId).isDefault;
              farmerCropQuantity.quantity = null; // 0;
              farmerCropQuantity.farmerId = this.id ? this.id : 0;
              this.farmerCropQuantities.push(farmerCropQuantity);
            });
            this.sortfarmerCropQuantities();
            this.saveFarmer(true, true);
          }
        }
      ]
    });

    await alert.present();
  }

  async addNutrientRecommendation() {
    const checkBoxes = [];
    this.nutrientRecommendations
      .filter(nr =>
        this.farmerNutrientRecommendationQuantities.map(fnrq => fnrq.nutrientRecommendationId).indexOf(nr.id) == -1
      )
      .forEach(nr => {
        checkBoxes.push({
          name: nr.name,
          type: 'checkbox',
          label: nr.name,
          value: nr.id,
          checked: false
        });
      });
    const alert = await this.alertController.create({
      header: 'Nutrient Recommendation(s)',
      inputs: checkBoxes,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (nrIds) => {
            nrIds.forEach(nrId => {
              const farmerNutrientRecommendationQuantity = new FarmerNutrientRecommendationQuantityDto();
              farmerNutrientRecommendationQuantity.nutrientRecommendationId = nrId;
              farmerNutrientRecommendationQuantity.nutrientRecommendationName = this.nutrientRecommendations.find(nr => nr.id == nrId).name;
              // if (this.nutrientRecommendations.find(nr => nr.id == nrId).isFullService) {
              //   farmerNutrientRecommendationQuantity.ownedQuantity = this.formGroup.controls.ownedAcres.value ? this.formGroup.controls.ownedAcres.value : null; // 0;
              //   farmerNutrientRecommendationQuantity.rentedQuantity = this.formGroup.controls.rentedAcres.value ? this.formGroup.controls.rentedAcres.value : null; // 0;
              // } else {
                farmerNutrientRecommendationQuantity.ownedQuantity = null; // 0;
                farmerNutrientRecommendationQuantity.rentedQuantity = null; // 0;
              // }
              farmerNutrientRecommendationQuantity.farmerId = this.id ? this.id : 0;
              this.farmerNutrientRecommendationQuantities.push(farmerNutrientRecommendationQuantity);
            });
            this.sortFarmerNutrientRecommendationQuantities();
            this.saveFarmer(true, true);
          }
        }
      ]
    });

    await alert.present();
  }

  sortfarmerCropQuantities() {
    this.farmerCropQuantities = this.farmerCropQuantities.sort(this.sortfarmerCropQuantity);
  }

  sortfarmerCropQuantity(a: FarmerCropQuantityDto, b: FarmerCropQuantityDto) {
    if (
      (a.cropIsDefault && !b.cropIsDefault) ||
      (b.cropIsDefault && !a.cropIsDefault)
    ) return 1;
    return a.cropName > b.cropName ? 1 : a.cropName < b.cropName ? -1 : 0;
  }

  sortFarmerNutrientSourceQuantities() {
    this.farmerNutrientSourceQuantities = this.farmerNutrientSourceQuantities.sort(this.sortFarmerNutrientSourceQuantity);
  }

  sortFarmerNutrientSourceQuantity(a: FarmerNutrientSourceQuantityDto, b: FarmerNutrientSourceQuantityDto) {
    return a.nutrientSourceSort > b.nutrientSourceSort ? 1 : a.nutrientSourceSort < b.nutrientSourceSort ? -1 : 0;
  }

  sortFarmerNutrientRecommendationQuantities() {
    this.farmerNutrientRecommendationQuantities = this.farmerNutrientRecommendationQuantities.sort(this.sortFarmerNutrientRecommendationQuantity);
  }

  sortFarmerNutrientRecommendationQuantity(a: FarmerNutrientRecommendationQuantityDto, b: FarmerNutrientRecommendationQuantityDto) {
    return a.nutrientRecommendationName > b.nutrientRecommendationName ? 1 : a.nutrientRecommendationName < b.nutrientRecommendationName ? -1 : 0;
  }

  sortFarmerManureStorages() {
    this.farmerManureStorages = this.farmerManureStorages.sort(this.sortFarmerManureStorage);
  }

  sortFarmerManureStorage(a: FarmerManureStorageDto, b: FarmerManureStorageDto) {
    return a.manureStorageSourceName > b.manureStorageSourceName ? 1 : a.manureStorageSourceName < b.manureStorageSourceName ? -1 : 0;
  }

  sortFarmerCostShares() {
    this.farmerCostShares = this.farmerCostShares.sort(this.sortFarmerCostShare);
  }

  sortFarmerCostShare(a: FarmerCostShareDto, b: FarmerCostShareDto) {
    return a.costShareName > b.costShareName ? 1 : a.costShareName < b.costShareName ? -1 : 0;
  }

  sortFarmerWatersheds() {
    this.farmerWatersheds = this.farmerWatersheds.sort(this.sortFarmerWatershed);
  }

  sortFarmerWatershed(a: FarmerWatershedDto, b: FarmerWatershedDto) {
    return a.watershedName > b.watershedName ? 1 : a.watershedName < b.watershedName ? -1 : 0;
  }

  sortAllRelatedEntities() {
    this.sortFarmerCounties();
    this.sortfarmerCropQuantities();
    this.sortFarmerNutrientSourceQuantities();
    this.sortFarmerNutrientRecommendationQuantities();
    this.sortFarmerManureStorages();
    this.sortFarmerCostShares();
    this.sortFarmerWatersheds();
  }


  // addDefaultCropQuantitiesIfNeeded() {
  //   this.crops.filter(crop => crop.isDefault).forEach(crop => {
  //     if (!this.farmerCropQuantities.find(fcq => fcq.cropId == crop.id)) {
  //       const farmerCropQuantity = new FarmerCropQuantityDto();
  //       if (this.id) {
  //         farmerCropQuantity.farmerId = this.id;
  //       }
  //       farmerCropQuantity.cropId = crop.id;
  //       farmerCropQuantity.cropName =  crop.name;
  //       farmerCropQuantity.cropIsDefault = true;
  //       farmerCropQuantity.quantity = null; // 0;
  //       this.farmerCropQuantities.push(farmerCropQuantity);
  //     }
  //   });
  // }

  addDefaultNutrientSourceQuantitiesIfNeeded() {
    this.nutrientSources.forEach(ns => {
      if (!this.farmerNutrientSourceQuantities.find(fnsq => fnsq.nutrientSourceId == ns.id)) {
        const farmerNutrientSourceQuantityDto = new FarmerNutrientSourceQuantityDto();
        if (this.id) {
          farmerNutrientSourceQuantityDto.farmerId = this.id;
        }
        farmerNutrientSourceQuantityDto.nutrientSourceId = ns.id;
        farmerNutrientSourceQuantityDto.nutrientSourceName = ns.name;
        farmerNutrientSourceQuantityDto.ownedQuantity = null; // 0;
        farmerNutrientSourceQuantityDto.rentedQuantity = null; // 0;
        this.farmerNutrientSourceQuantities.push(farmerNutrientSourceQuantityDto);
      }
    });
  }

  nmpCompleteRadioSelect(event) {
    if (this.formGroup.controls.nmpComplete.value != null) {
      if (this.formGroup.controls.nmpComplete.value) {
        this.formGroup.controls.nmpCompletionDate.setValidators([Validators.required]);
        this.formGroup.controls.nmpTypeId.setValidators([Validators.required]);
        this.formGroup.controls.nmpAcreageQuantity.setValidators([Validators.required]);
        this.formGroup.controls.nmpHasBeenStarted.clearValidators();
      } else {
        this.formGroup.controls.nmpCompletionDate.clearValidators();
        this.formGroup.controls.nmpTypeId.clearValidators();
        this.formGroup.controls.nmpAcreageQuantity.clearValidators();
        this.formGroup.controls.nmpHasBeenStarted.setValidators([Validators.required]);
      }
      this.formGroup.controls.nmpCompletionDate.updateValueAndValidity();
      this.formGroup.controls.nmpTypeId.updateValueAndValidity();
      this.formGroup.controls.nmpAcreageQuantity.updateValueAndValidity();
      this.formGroup.controls.nmpHasBeenStarted.updateValueAndValidity();
    }
  }

  factCompleteRadioSelect(event) {
    if (this.formGroup.controls.factComplete.value != null) {
      if (this.formGroup.controls.factComplete.value) {
        this.formGroup.controls.factCompletionDate.setValidators([Validators.required]);
      } else {
        this.formGroup.controls.factCompletionDate.clearValidators();
      }
      this.formGroup.controls.factCompletionDate.updateValueAndValidity();
    }
  }

  async submitForm() {
    if (this.isFormValid()) {
      this.saveFarmer(false, false);
    } else {
      const alert = await this.alertController.create({
        header: 'Error',
        // subHeader: 'Error',
        message: 'Please fill in all required fields and/or correct form errors',
        buttons: ['OK']
      });

      await alert.present();
    }
  }

  isFormValid() {
    return this.getMissingRequiredFields().length == 0 && this.getSecondaryErrors().length == 0
  }

  getMissingRequiredFields() {
    let missingRequiredFields = [];

    if (!this.formGroup.valid) {
      if (!this.formGroup.controls.firstName.value) {
        missingRequiredFields.push('First Name');
      }
      if (!this.formGroup.controls.lastName.value) {
        missingRequiredFields.push('Last Name');
      }
      if (!this.formGroup.controls.emailAddress.value) {
        missingRequiredFields.push('Email Address');
      }
      if (!this.formGroup.controls.phoneNumber.value) {
        missingRequiredFields.push('Phone Number');
      }
      if (!this.formGroup.controls.userName.value) {
        missingRequiredFields.push('User Name');
      }
      if (this.id) {
        if (!this.formGroup.controls.farmName.value) {
          missingRequiredFields.push('Farm Name');
        }
        if (!this.formGroup.controls.address.value) {
          missingRequiredFields.push('Address');
        }
        if (!this.formGroup.controls.city.value) {
          missingRequiredFields.push('City');
        }
        if (!this.formGroup.controls.zipCode.value) {
          missingRequiredFields.push('Zip Code');
        }
        if (
          !this.formGroup.controls.ownedAcres.value && 
          this.formGroup.controls.ownedAcres.value != 0
        ) {
          missingRequiredFields.push('Owned/Controlled Acres');
        }
        if (
          !this.formGroup.controls.rentedAcres.value && 
          this.formGroup.controls.rentedAcres.value != 0
        ) {
          missingRequiredFields.push('Rented Acres');
        }
        if (this.formGroup.controls.nmpComplete.value == null) {
          missingRequiredFields.push('NMP Complete');
        } else {
          if (this.formGroup.controls.nmpComplete.value) {
            if (!this.formGroup.controls.nmpCompletionDate.value) {
              missingRequiredFields.push('NMP Date Completed');
            }
            if (!this.formGroup.controls.nmpTypeId.value) {
              missingRequiredFields.push('NMP Type');
            }
            if (
              !this.formGroup.controls.nmpAcreageQuantity.value &&
              this.formGroup.controls.nmpAcreageQuantity.value != 0
            ) {
              missingRequiredFields.push('NMP Acreage Quantity');
            }
          } else {
            if (this.formGroup.controls.nmpHasBeenStarted.value == null) {
              missingRequiredFields.push('NMP has been started?');
            }
          }
        }
        if (this.formGroup.controls.factComplete.value == null) {
          missingRequiredFields.push('FACT Complete');
        } else {
          if (this.formGroup.controls.factComplete.value) {
            if (!this.formGroup.controls.factCompletionDate.value) {
              missingRequiredFields.push('FACT Date Completed');
            }
          }
        }
        if (
          !this.formGroup.controls.nutrientApplication.value &&
          this.formGroup.controls.nutrientApplication.value != 0
        ) {
          missingRequiredFields.push('Nutrient Application Frozen/Snow Covered Grounds');
        }
        if (
          !this.formGroup.controls.sensitiveAreas.value &&
          this.formGroup.controls.sensitiveAreas.value != 0
        ) {
          missingRequiredFields.push('Sensitive Areas Located and Mapped');
        }
        if (
          this.formGroup.controls.infoRepresentsEntireFarmingOperation.value == null ||
          this.formGroup.controls.infoRepresentsEntireFarmingOperation.value == false
        ) {
          missingRequiredFields.push('Information represents farming operation');
        }
        if (
          this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.value == null ||
          this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.value == false
        ) {
          missingRequiredFields.push('Information subject to audit by independent auditors');
        }
        if (
          this.formGroup.controls.infoFairAndAccurateToBestAbility.value == null ||
          this.formGroup.controls.infoFairAndAccurateToBestAbility.value == false
        ) {
          missingRequiredFields.push('Information fair and accurate to best of ability');
        }
      }
    }

    return missingRequiredFields;
  }

  getSecondaryErrors() {
    let secondaryErrors = [];

    // // Need crops to add up to total acres
    // const totalAcresFarmed = this.formGroup.controls.ownedAcres.value + this.formGroup.controls.rentedAcres.value;
    // let totalAcresPerCropRotation = 0;
    // this.farmerCropQuantities.forEach(fcq => totalAcresPerCropRotation += fcq.quantity);
    // if (totalAcresFarmed != totalAcresPerCropRotation) {
    //   secondaryErrors.push('Total crop acres in rotation doesn\'t add up to total acres farmed')
    // }

    if (this.id) {
      if (
        !(this.farmerCropQuantities && this.farmerCropQuantities.length > 0)
      ) {
        secondaryErrors.push('Crops are required');
      } else if(
        this.farmerCropQuantities.filter(x => x.quantity == null).length > 0
      ) {
        secondaryErrors.push('Acres quantity required for all Crops');
      }
    }

    return secondaryErrors;
  }

  async saveFarmer(didCheckUserExists: boolean, noConfirmationMessage: boolean) {

    if (!didCheckUserExists && !(this.user && this.user.id)) {

      const loading = await this.loadingController.create({
        message: 'Checking if User with provided Email exists...',
      });
      await loading.present();

      this.userService.doesUserExist(this.formGroup.controls.userName.value).subscribe(async response => {
        await loading.dismiss();

        if (response) {

          const alert = await this.alertController.create({
            header: 'Error',
            message: 'There is already a user with this User Name',
            buttons: [
              {
                text: 'Okay',
                handler: () => {

                }
              }
            ]
          });

          await alert.present();
        } else {
          this.saveFarmer(true, false);
        }
      });
      return;
    }

    if (!this.id && !this.formGroup.valid) return;

    if (this.isSaving) {
      setTimeout(() => {
        this.saveFarmer(true, false);
      }, 250);
      return
    }

    this.isSaving = true;

    let loading = null;

    if(!noConfirmationMessage){
      loading = await this.loadingController.create({
        message: 'Saving Farmer Profile...',
      });
      await loading.present();
    }

    const request = new FarmerSaveDto();

    const formValues = this.formGroup.getRawValue();

    const userDto = this.user ? this.user : new UserDto();
    const fullName = formValues.firstName + ' ' + formValues.lastName;
    userDto.firstName = formValues.firstName;
    userDto.lastName = formValues.lastName;
    userDto.emailAddress = formValues.emailAddress;
    userDto.phoneNumber = formValues.phoneNumber;
    userDto.name = fullName;
    userDto.surname = fullName;
    userDto.fullName = fullName;
    userDto.userName = formValues.userName;
    userDto.isActive = true;

    const farmerDto = this.farmer ? this.farmer : new FarmerDto();
    farmerDto.farmName = formValues.farmName;
    farmerDto.address = formValues.address;
    farmerDto.city = formValues.city;
    farmerDto.zipCode = formValues.zipCode;
    farmerDto.ownedAcres = formValues.ownedAcres;
    farmerDto.rentedAcres = formValues.rentedAcres;
    farmerDto.nmpComplete = formValues.nmpComplete;
    farmerDto.nmpCompletionDate = formValues.nmpCompletionDate ? new Date(formValues.nmpCompletionDate) : formValues.nmpCompletionDate;
    farmerDto.nmpHasBeenStarted = formValues.nmpHasBeenStarted;
    farmerDto.nmpTypeId = formValues.nmpTypeId;
    farmerDto.nmpAcreageQuantity = formValues.nmpAcreageQuantity;
    farmerDto.factComplete = formValues.factComplete;
    farmerDto.factCompletionDate = formValues.factCompletionDate ? new Date(formValues.factCompletionDate) : formValues.factCompletionDate;
    farmerDto.nutrientApplication = formValues.nutrientApplication;
    farmerDto.sensitiveAreas = formValues.sensitiveAreas;
    farmerDto.infoRepresentsEntireFarmingOperation = formValues.infoRepresentsEntireFarmingOperation;
    farmerDto.infoSubjectToAuditByIndependentAuditors = formValues.infoSubjectToAuditByIndependentAuditors;
    farmerDto.infoFairAndAccurateToBestAbility = formValues.infoFairAndAccurateToBestAbility;

    request.userDto = userDto;
    request.farmerDto = farmerDto;

    this.farmerSvc.save(request).subscribe(
      async response => {
        if (!this.id) { // new farmer
          this.makeFarmerFieldsRequired();
        }
        this.id = response.farmerDto.id;
        this.farmer = response.farmerDto;
        this.user = response.userDto;
        this.enableOrDisableInformationCheckboxes();
        this.saveAllRelatedEntities();
        if(!noConfirmationMessage){
          await loading.dismiss();
        }
        
        if(!noConfirmationMessage){
          const alert = await this.alertController.create({
            header: 'Success',
            message: 'Farmer Profile has been saved',
            buttons: ['OK']
          });
          await alert.present();
        }

      },
      async error => {
        this.saveFarmerError(error).then();
        await loading.dismiss();
      }
    );
  }

  saveAllRelatedEntities() {
    this.assignFarmerIdToJoinTableEntities();
    this.isSavingFarmerCounties = true;
    this.isSavingFarmerCropQuantities = true;
    this.isSavingFarmerNutrientSourceQuantities = true;
    this.isSavingFarmerNutrientRecommendationQuantities = true;
    this.isSavingFarmerCostShares = true;
    this.isSavingFarmerWatersheds = true;
    this.farmerCountyService.createOrUpdateAll(<any>this.farmerCounties).subscribe(farmerCountiesResponse => {
      this.farmerCounties = farmerCountiesResponse;
      this.sortFarmerCounties();
      this.isSavingFarmerCounties = false;
      this.checkIfAllRelatedEntitiesAreDoneSaving();
    });
    this.farmerCropQuantityService.createOrUpdateAll(<any>this.farmerCropQuantities).subscribe(farmerCropQuantitiesResponse => {
      this.farmerCropQuantities = farmerCropQuantitiesResponse;
      this.sortfarmerCropQuantities();
      this.isSavingFarmerCropQuantities = false;
      this.checkIfAllRelatedEntitiesAreDoneSaving();
    });
    this.farmerNutrientSourceQuantityService.createOrUpdateAll(<any>this.farmerNutrientSourceQuantities).subscribe(farmerNutrientSourceQuantitiesResponse => {
      this.farmerNutrientSourceQuantities = farmerNutrientSourceQuantitiesResponse;
      this.sortFarmerNutrientSourceQuantities();
      this.isSavingFarmerNutrientSourceQuantities = false;
      this.checkIfAllRelatedEntitiesAreDoneSaving();
    });
    this.farmerNutrientRecommendationQuantityService.createOrUpdateAll(<any>this.farmerNutrientRecommendationQuantities).subscribe(farmerNutrientRecommendationQuantitiesResponse => {
      this.farmerNutrientRecommendationQuantities = farmerNutrientRecommendationQuantitiesResponse;
      this.sortFarmerNutrientRecommendationQuantities();
      this.isSavingFarmerNutrientRecommendationQuantities = false;
      this.checkIfAllRelatedEntitiesAreDoneSaving();
    });
    // manure storage done in modal
    this.farmerCostShareService.createOrUpdateAll(<any>this.farmerCostShares).subscribe(farmerCostSharesResponse => {
      this.farmerCostShares = farmerCostSharesResponse;
      this.sortFarmerCostShares();
      this.isSavingFarmerCostShares = false;
      this.checkIfAllRelatedEntitiesAreDoneSaving();
    });
    this.farmerWatershedService.createOrUpdateAll(<any>this.farmerWatersheds).subscribe(farmerWatershedsResponse => {
      this.farmerWatersheds = farmerWatershedsResponse;
      this.sortFarmerWatersheds();
      this.isSavingFarmerWatersheds = false;
      this.checkIfAllRelatedEntitiesAreDoneSaving();
    });
  }

  checkIfAllRelatedEntitiesAreDoneSaving() {
    if (
      !this.isSavingFarmerCounties &&
      !this.isSavingFarmerCropQuantities &&
      !this.isSavingFarmerNutrientSourceQuantities &&
      !this.isSavingFarmerNutrientRecommendationQuantities &&
      !this.isSavingFarmerCostShares &&
      !this.isSavingFarmerWatersheds
    ) {
      this.isSaving = false;
      // no longer clear in app.component so have to do it here
      if (this.router.url.indexOf('/account/login') > -1) this.appStorageService.clearToken();
    }
  }

  assignFarmerIdToJoinTableEntities() {
    this.farmerCounties.forEach(x => x.farmerId = this.id);
    this.farmerCropQuantities.forEach(x => x.farmerId = this.id);
    this.farmerNutrientSourceQuantities.forEach(x => x.farmerId = this.id);
    this.farmerNutrientRecommendationQuantities.forEach(x => x.farmerId = this.id);
    this.farmerCostShares.forEach(x => x.farmerId = this.id);
    this.farmerWatersheds.forEach(x => x.farmerId = this.id);
  }

  async saveFarmerError(errorMessage) {
    const alert = await this.alertController.create({
      header: 'Error',
      subHeader: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });

    // await alert.present();
  }

  cancel() {
    this.navCtrl.back();
    // this.router.navigate(['/main/home']);
  }

  async addNewCertification() {

    const loading = await this.loadingController.create({
      message: 'Creating certification...',
    });
    await loading.present();
    
    const request = new CCertificationDto();
    request.farmerId = this.id;
    request.year = (new Date()).getFullYear();
    this.certificationService.save(request).subscribe(async cert => {
      await loading.dismiss();
      this.goToCertification(cert.id);
    });
  }

  goToCertification(id: number, isView: boolean = false) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        isView: isView,
        certificationId: id,
        farmer: JSON.stringify(this.farmer),
        farmerCrops: JSON.stringify(this.farmerCropQuantities),
        farmerNutrientSources: JSON.stringify(this.farmerNutrientSourceQuantities),
        farmerNutrientRecommendations: JSON.stringify(this.farmerNutrientRecommendationQuantities)
      }
    };
    this.router.navigate(['/main/certification'], navigationExtras);
  }

  goToCertificationScore(id: number) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        certificationId: id
      }
    };
    this.router.navigate(['/main/certification-score'], navigationExtras);
  }

  hasOwnedAcres() {
    return this.formGroup.controls.ownedAcres.value && this.formGroup.controls.ownedAcres.value > 0
  }

  hasRentedAcres() {
    return this.formGroup.controls.rentedAcres.value && this.formGroup.controls.rentedAcres.value > 0
  }

  async addManureStorage() {
    const modal = await this.modalController.create({
      component: ManureStoragePage,
      componentProps: {
        'farmerId': this.id,
      }
    });
    modal.onDidDismiss().then((param) => {
      if (param && param.data && param.data['dto']) {
        this.farmerManureStorages.push(param.data['dto']);
        this.sortFarmerManureStorages();
      }
      this.saveFarmer(true, true);
    });
    return await modal.present();
  }

  getFarmerManureStorageDescription(fms: FarmerManureStorageDto) {
    return fms.manureStorageSourceName + ' - ' +
      fms.manureStorageDurationName + ' - ' +
      fms.manureStorageTypeName;
  }

  removeManureStorage(fms: FarmerManureStorageDto) {
    if (fms.id > 0) {
      this.farmerManureStorageService.delete(fms.id).subscribe(() => { });
    }
    const index = this.farmerManureStorages.indexOf(fms);
    this.farmerManureStorages.splice(index, 1);
  }

  removeCostShare(fcs: FarmerCostShareDto) {
    if (fcs.id > 0) {
      this.farmerCostShareService.delete(fcs.id).subscribe(() => { });
    }
    const index = this.farmerCostShares.indexOf(fcs);
    this.farmerCostShares.splice(index, 1);
  }

  async addCostShare() {
    const checkBoxes = [];
    this.costShares
      .filter(costShare =>
        this.farmerCostShares.map(fc => fc.costShareId).indexOf(costShare.id) == -1
      )
      .forEach(costShare => {
        checkBoxes.push({
          name: costShare.name,
          type: 'checkbox',
          label: costShare.name,
          value: costShare.id,
          checked: false
        });
      });
    const alert = await this.alertController.create({
      header: 'Cost Share(s)',
      inputs: checkBoxes,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (costShareIds) => {
            costShareIds.forEach(costShareId => {
              const farmerCostShare = new FarmerCostShareDto();
              farmerCostShare.costShareId = costShareId;
              farmerCostShare.costShareName = this.costShares.find(c => c.id == costShareId).name;
              farmerCostShare.farmerId = this.id ? this.id : 0;
              this.farmerCostShares.push(farmerCostShare);
            });
            this.sortFarmerCostShares();
            this.saveFarmer(true, true);
          }
        }
      ]
    });

    await alert.present();
  }

  async addNewWatershed() {
    const checkBoxes = [];
    this.watersheds
      .filter(watershed =>
        this.farmerWatersheds.map(fw => fw.watershedId).indexOf(watershed.id) == -1
      )
      .forEach(watershed => {
        checkBoxes.push({
          name: watershed.name + ' ' + watershed.code,
          type: 'checkbox',
          label: watershed.name + ' ' + watershed.code,
          value: watershed.id,
          checked: false
        });
      });
    const alert = await this.alertController.create({
      header: 'Watershed(s)',
      inputs: checkBoxes,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Ok',
          handler: (watershedIds) => {
            watershedIds.forEach(watershedId => {
              const farmerWatershed = new FarmerWatershedDto();
              farmerWatershed.watershedId = watershedId;
              farmerWatershed.watershedName = this.watersheds.find(c => c.id == watershedId).name;
              farmerWatershed.watershedCode = this.watersheds.find(c => c.id == watershedId).code;
              farmerWatershed.farmerId = this.id ? this.id : 0;
              this.farmerWatersheds.push(farmerWatershed);
            });
            this.sortFarmerWatersheds();
            this.saveFarmer(true, true);
          }
        }
      ]
    });

    await alert.present();
  }

  initializeNewFarmer() {
    this.id = null;
    this.farmer = new FarmerDto();
    this.user = new UserDto();
  }

  isCertificationCompleteStatus(certification: CCertificationDto) {
    if (!this.certifications) return false;
    return this.certifications.find(cert => cert.id == certification.id).statusId == 2;
  }

  isAdmin() {
    return this.permissionChecker.isGranted("Pages.Certifications");
  }

  getEnabledFeatures() : FeatureMap{
    return AppConsts.enabledFeatures;
  }

  private registerTextMask(inputElement: HTMLInputElement) {
    const maskedInput = createTextMaskInputElement({
      inputElement,
      mask: this.phoneMask,
      guide: false,
    });
    this.phoneNumber.valueChanges.subscribe(value => {
      maskedInput.update(value);
    });
  }

  removeNutrientRecommendation(farmerNutrientRecommendation: FarmerNutrientRecommendationQuantityDto) {
    if (farmerNutrientRecommendation.id > 0) {
      this.farmerNutrientRecommendationQuantityService.delete(farmerNutrientRecommendation.id).subscribe(() => {});
    }
    const index = this.farmerNutrientRecommendationQuantities.indexOf(farmerNutrientRecommendation);
    this.farmerNutrientRecommendationQuantities.splice(index, 1);
  }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      header: '',
      message: msg,
      buttons: ['OK']
    });

    await alert.present();
  }

  disableNewCertButton() {
    if (this.certifications && this.isFormValid()) {
      return (this.certifications.find(x => x.year == (new Date()).getFullYear() && x.isPassing) != null ||
        this.certifications.find(x => x.statusId < CCertificationStatusEnum._2) != null) // &&
        // !this.isAdmin();
    } else if(!this.isFormValid()){
      return true;
    }
     else {
      return false;
    }
  }

  openWatershedLink() {
    window.open(this.watershedlink, "_blank");
  }

  print() {

    window.open(`${this.baseUrl}/print/farmer/${this.id}?${AppConsts.authorization.encryptedAuthTokenName}=${encodeURIComponent(this.encToken)}`, '_blank');

  }

  enableOrDisableInformationCheckboxes() {
    if (!this.formGroup.controls.infoRepresentsEntireFarmingOperation.value) {
      this.formGroup.controls.infoRepresentsEntireFarmingOperation.enable();
    } else {
      this.formGroup.controls.infoRepresentsEntireFarmingOperation.disable();
    }
    if (!this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.value) {
      this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.enable();
    } else {
      this.formGroup.controls.infoSubjectToAuditByIndependentAuditors.disable();
    }
    if (!this.formGroup.controls.infoFairAndAccurateToBestAbility.value) {
      this.formGroup.controls.infoFairAndAccurateToBestAbility.enable();
    } else {
      this.formGroup.controls.infoFairAndAccurateToBestAbility.disable();
    }
  }

  acreageChange(type, value) {
    if (!this.farmer) return;
    if (!value || value == 0) {
      if (type == 0) {
        this.farmerNutrientSourceQuantities.forEach(x => x.ownedQuantity = null);
      }
      if (type == 1) {
        this.farmerNutrientSourceQuantities.forEach(x => x.rentedQuantity = null);
      }
    }
  }

}
